import * as React from 'react';
import config from '../config';
import classnames from 'classnames';

export const EnvironmentHeader = () => {
  return <div className={classnames('environment', `environment-${config.API_ENV}`)}>{config.API_ENV}</div>;
};
